var React = require('react');

function WaveBottom (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1440 61.8H0V.4L99.4 11l92.4 8.1a6627.6 6627.6 0 0 0 951.6 14.5l148.3-9.8L1440 10v51.8Z","fill":"#fff"}));
}

WaveBottom.defaultProps = {"width":"1440","height":"62","viewBox":"0 0 1440 62","fill":"none"};

module.exports = WaveBottom;

WaveBottom.default = WaveBottom;
